import { Stack } from "@mui/material"
import Kpi from "../Tools/Kpi"
import { useContext} from "react"
import UserContext from "../../services/Context/UserContext"
import { txt } from "../../services/translation"

export default function Kpis({data}){

    const {user} = useContext(UserContext)

    const color = user.category?.color;

    return data && <Stack spacing={1}>
        <Stack direction='row' flexWrap='wrap'>
            <Kpi 
                title={(data.users || 0).toLocaleString()}
                caption={txt('users')}
                icon='people'
                color={color}
                sx={{mr: 1, mb: 1}}
            />

            <Kpi 
                title={(data.enrollments || 0).toLocaleString()}
                caption={txt('enrollments')}
                icon='school'
                color={color}
                sx={{mr: 1, mb: 1}}
            />

            <Kpi 
                title={(data.completion || 0).toLocaleString()}
                unit={'%'}
                caption={txt('averageCompletion')}
                icon='check'
                color={color}
                sx={{mr: 1, mb: 1}}
            />
        </Stack>
    </Stack>

}

